/* eslint-disable */
require('./area')
require('./corner')
require('./goal')
require('./nogoal')
require('./noredcard')
require('./noyellowcard')
require('./noyellowredcard')
require('./penaltynotscored')
require('./redcard')
require('./referee')
require('./scoringchance')
require('./shotnotontarget')
require('./shotontarget')
require('./substitution')
require('./timeout')
require('./var')
require('./yellowcard')
require('./yellowredcard')
